<template>
  <div>
    <v-switch v-model="model" :label="textMsg" class="display-22" color="primary" />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: 'text'
    },

    disableText: {
      type: String,
      default: ''
    },

    initialVal: {
      type: Boolean
    }
  },

  data() {
    return {
      switcher: undefined
    }
  },

  computed: {
    model: {
      get() {
        return this.initialVal
      },
      set(val) {
        this.switcher = val
      }
    },

    textMsg() {
      return this.initialVal ? this.label : this.disableText
    }
  },

  watch: {
    switcher() {
      this.$emit('changeSetting', this.switcher)
    }
  }
}
</script>
